.md {
  font-size: var(--mantine-font-size-md);
  line-height: 1.65;
}
.md table {
  width: 100%;
  border-collapse: collapse;
  display: block;
  overflow-x: auto;
  font-size: var(--mantine-font-size-sm);
}
.md th,
.md td {
  border: 1px solid var(--mantine-color-default-border);
  padding: 8px 10px;
  vertical-align: top;
}
.md th {
  background: var(--mantine-color-default-hover);
  text-align: left;
}
.md blockquote {
  border-left: 3px solid var(--mantine-color-blue-5);
  background: var(--mantine-color-blue-light);
  border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;
  padding: 10px 16px;
  margin: 16px 0;
}
.md blockquote p {
  margin: 0;
}
.md code {
  font-size: 0.9em;
}
